export type NotificationType =
  | 'approval.user.pending'
  | 'approval.company.pending'
  | 'approval.employee.pending'
  | 'approval.request.approved'
  | 'approval.request.rejected'
  | 'approval.request.commented'
  | 'pdf.generation.done'
  | 'pdf.generation.failed';

export interface NotificationData {
  userId?: string;
  companyId?: string;
  employeeId?: string;
  fullName?: string;
  email?: string;
  title?: string;
  ico?: string;
  companyTitle?: string;
  pdfId?: string;
  documentId?: string;
  documentationId?: string;
  name?: string;
  downloadUrl?: string;
  reason?: string;
  requestId?: string;
  objectType?: string;
  objectId?: string;
  comment?: string;
  actorName?: string;
  [key: string]: unknown;
}

/** WebSocket data envelope pushed by the gateway. */
export interface NotificationEnvelope {
  id: string;
  type: NotificationType | string;
  topic: string;
  time: string;
  seq: number;
  traceId?: string;
  data: NotificationData;
}

/** Item shape returned by the REST list endpoint (camelCase). */
export interface NotificationRestItem {
  id: string;
  type: NotificationType | string;
  data: NotificationData;
  seq: number;
  isRead: boolean;
  readAt: string | null;
  isDismissed: boolean;
  dismissedAt: string | null;
  createdOn: string;
}

/** Normalized item stored in Redux (unifies WS envelope and REST item). */
export interface NotificationItem {
  id: string;
  type: NotificationType | string;
  data: NotificationData;
  seq: number;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationSnapshot {
  unreadCount: number;
  unreadByType: Record<string, number>;
  lastSeq: number;
}

export type NotificationConnectionStatus = 'idle' | 'connecting' | 'open' | 'closed';

export interface NotificationsState {
  items: NotificationItem[];
  unreadCount: number;
  unreadByType: Record<string, number>;
  lastSeq: number;
  connection: NotificationConnectionStatus;
  loading: boolean;
}

export const normalizeEnvelope = (envelope: NotificationEnvelope): NotificationItem => ({
  id: envelope.id,
  type: envelope.type,
  data: envelope.data ?? {},
  seq: envelope.seq,
  isRead: false,
  createdAt: envelope.time,
});

export const normalizeRestItem = (item: NotificationRestItem): NotificationItem => ({
  id: item.id,
  type: item.type,
  data: item.data ?? {},
  seq: item.seq,
  isRead: item.isRead,
  createdAt: item.createdOn,
});
